import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faPhoneAlt, faMobileAlt, faTv, faVideo } from '@fortawesome/free-solid-svg-icons';
import styles from '../css/comuns/Servicos.module.css';
import { config } from '../../data';

const Servicos = () => {
    // Mapeamento de ícones
    const iconMap = {
        faGlobe,
        faPhoneAlt,
        faMobileAlt,
        faTv,
        faVideo,
    };

    const servicos = config.content.servicos.map(servico => ({
        ...servico,
        icon: iconMap[servico.icon],
    }));

    return (
        <section id="servicos" className={`${styles['secao']} py-5 ${styles['fundo-claro']}`}>
            <div className="container">
                <h2 className={`text-center ${styles['texto-oni-azul']} mb-5`}>{config.texts.servicos.title}</h2>
                <div className={styles['grade-servicos']}>
                    {servicos.map((servico, index) => (
                        <div className={styles['cartao']} key={index}>
                            <div className={`${styles['corpo-cartao']} text-center`}>
                                <div className={styles['icone-wrapper']}>
                                    <FontAwesomeIcon icon={servico.icon} className={styles['icone-cartao']} />
                                </div>
                                <h3 className={styles['titulo-cartao']}>{servico.titulo}</h3>
                                <p className={styles['texto-cartao']}>{servico.descricao}</p>
                                <ul className="list-unstyled">
                                    {servico.recursos.map((recurso, idx) => (
                                        <li key={idx}>{recurso}</li>
                                    ))}
                                </ul>
                                <a href="#" className={`btn ${styles['botao-oni']} mt-3`}>{config.texts.servicos.buttonText}</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Servicos;